function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import omit from 'object.omit';
import { format as formatDate } from 'date-fns';
import { VRangeDatePicker } from '@cloud-sn/v-datepicker';
import { buildComponentName } from '../utils';
import Icon from '../icon';
import localeCN from './locale/zh_CN';
var __vue_script__ = {
  name: buildComponentName('RangeDatePicker'),
  components: {
    VRangeDatePicker: VRangeDatePicker,
    Icon: Icon
  },
  model: {
    prop: 'selectedValue'
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-calendar'
    },
    locale: {
      type: Object,
      default: function _default() {
        return localeCN.lang;
      }
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    selectedValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mode: {
      type: Array,
      validator: function validator(val) {
        return val.every(function (v) {
          return ['time', 'date', 'month'].indexOf(v) > -1;
        });
      },
      default: function _default() {
        return ['date', 'date'];
      }
    },
    theme: {
      type: String,
      default: 'light'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: null
    },
    showTime: {
      type: [Boolean, Object],
      default: false
    },
    showOk: {
      type: Boolean,
      default: undefined
    },
    disabledDate: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    disabledTime: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    placeholder: {
      type: [String, Array],
      default: ''
    },
    showToday: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    ranges: {
      type: [Object, Array],
      default: undefined
    },
    placement: {
      type: String,
      default: 'bottomLeft',
      validator: function validator(val) {
        return ['bottomLeft', 'bottomRight', 'topRight', 'topLeft'].indexOf(val) > -1;
      }
    },
    transitionName: {
      type: String,
      default: 'slide-up'
    },
    animation: {
      type: String,
      default: ''
    },
    getPopupContainer: {
      type: Function,
      default: null
    },
    // 当未设置 selectedValue 时,通过此项设置弹窗默认值
    openValue: {
      type: Array,
      default: undefined
    },
    okConfirm: {
      type: Boolean,
      default: false
    },
    controlMode: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(value) {
        return ['small', 'large', 'default'].indexOf(value) > -1;
      }
    }
  },
  data: function data() {
    return {
      innerValue: null
    };
  },
  computed: {
    isShowOk: function isShowOk() {
      var showOk = this.showOk,
          showTime = this.showTime;
      return showOk === true || showOk !== false && !!showTime;
    },
    normalizeLocale: function normalizeLocale() {
      var locale = this.locale;

      if (!locale) {
        return localeCN.lang;
      }

      return locale.lang ? locale.lang : locale;
    },
    bindProps: function bindProps() {
      var $props = this.$props,
          prefixCls = this.prefixCls,
          innerValue = this.innerValue,
          startPlaceholder = this.startPlaceholder,
          endPlaceholder = this.endPlaceholder,
          openValue = this.openValue,
          dateFormat = this.dateFormat,
          isShowOk = this.isShowOk,
          normalizeLocale = this.normalizeLocale;
      return _objectSpread({}, omit($props, ['format', 'allowClear', 'size', 'placeholder']), {
        selectedValue: innerValue,
        pickerPrefixCls: "".concat(prefixCls, "-picker-container"),
        dateInputPlaceholder: [startPlaceholder, endPlaceholder],
        value: openValue || undefined,
        format: dateFormat,
        showOk: isShowOk,
        locale: normalizeLocale
      });
    },
    bindListeners: function bindListeners() {
      return omit(this.$listeners, ['change']);
    },
    startPlaceholder: function startPlaceholder() {
      var placeholder = this.placeholder,
          normalizeLocale = this.normalizeLocale;
      var rangePlaceholder = normalizeLocale.rangePlaceholder;
      var holder = rangePlaceholder[0];

      if (placeholder) {
        if (Array.isArray(placeholder)) {
          if (placeholder.length > 0) {
            var _placeholder = _slicedToArray(placeholder, 1);

            holder = _placeholder[0];
          }
        } else {
          holder = placeholder;
        }
      }

      return holder;
    },
    endPlaceholder: function endPlaceholder() {
      var placeholder = this.placeholder,
          normalizeLocale = this.normalizeLocale;
      var rangePlaceholder = normalizeLocale.rangePlaceholder;
      var holder = rangePlaceholder[1];

      if (placeholder) {
        if (Array.isArray(placeholder)) {
          if (placeholder.length > 1) {
            var _placeholder2 = _slicedToArray(placeholder, 2);

            holder = _placeholder2[1];
          } else if (placeholder.length > 0) {
            var _placeholder3 = _slicedToArray(placeholder, 1);

            holder = _placeholder3[0];
          }
        } else {
          holder = placeholder;
        }
      }

      return holder;
    },
    pickerClasses: function pickerClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          theme = this.theme,
          size = this.size;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-picker"), true), _defineProperty(_ref, "".concat(prefixCls, "-picker-").concat(theme), true), _defineProperty(_ref, "".concat(prefixCls, "-picker-").concat(size), true), _ref;
    },
    pickerInputClass: function pickerInputClass() {
      var _ref2;

      var prefixCls = this.prefixCls,
          disabled = this.disabled,
          size = this.size;
      var inputPrefix = 'ux-input';
      var map = {
        small: 'sm',
        large: 'lg'
      };
      return _ref2 = {}, _defineProperty(_ref2, inputPrefix, true), _defineProperty(_ref2, "".concat(prefixCls, "-picker-input"), true), _defineProperty(_ref2, "".concat(inputPrefix, "-disabled"), disabled), _defineProperty(_ref2, "".concat(inputPrefix, "-").concat(map[size]), size !== 'default'), _ref2;
    },
    isCanClear: function isCanClear() {
      var disabled = this.disabled,
          allowClear = this.allowClear,
          innerValue = this.innerValue;

      var _innerValue = _slicedToArray(innerValue, 2),
          start = _innerValue[0],
          end = _innerValue[1];

      return !disabled && allowClear && (start || end);
    },
    isShowTime: function isShowTime() {
      return !!this.showTime;
    },
    dateFormat: function dateFormat() {
      var format = this.format,
          isShowTime = this.isShowTime;
      return format || (isShowTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD');
    },
    startValue: function startValue() {
      var innerValue = this.innerValue,
          dateFormat = this.dateFormat;

      var _innerValue2 = _slicedToArray(innerValue, 1),
          start = _innerValue2[0];

      return start ? formatDate(start, dateFormat) : '';
    },
    endValue: function endValue() {
      var innerValue = this.innerValue,
          dateFormat = this.dateFormat;

      var _innerValue3 = _slicedToArray(innerValue, 2),
          end = _innerValue3[1];

      return end ? formatDate(end, dateFormat) : '';
    }
  },
  watch: {
    selectedValue: function selectedValue(nVal, oVal) {
      if (nVal !== oVal) {
        this.innerValue = nVal || [];
      }
    }
  },
  created: function created() {
    this.innerValue = this.selectedValue || [];
  },
  methods: {
    setValue: function setValue(values, formatDateStrings) {
      this.innerValue = values || [];
      this.$emit('input', values);
      this.$emit('change', values, formatDateStrings);
    },
    onChange: function onChange(values, formatDateStrings) {
      this.setValue(values, formatDateStrings);
    },
    onClearClick: function onClearClick() {
      this.setValue([]);
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-range-date-picker', _vm._g(_vm._b({
    on: {
      "change": _vm.onChange
    }
  }, 'v-range-date-picker', _vm.bindProps, false), _vm.bindListeners), [_c('template', {
    slot: "trigger"
  }, [_c('div', {
    class: _vm.pickerClasses
  }, [_c('div', {
    class: _vm.pickerInputClass
  }, [_c('input', {
    class: _vm.prefixCls + "-range-picker-input",
    attrs: {
      "placeholder": _vm.startPlaceholder,
      "disabled": _vm.disabled,
      "type": "text",
      "readonly": "",
      "tabindex": "-1"
    },
    domProps: {
      "value": _vm.startValue
    }
  }), _c('span', {
    class: _vm.prefixCls + "-range-picker-separator"
  }, [_vm._v(" ~ ")]), _c('input', {
    class: _vm.prefixCls + "-range-picker-input",
    attrs: {
      "placeholder": _vm.endPlaceholder,
      "disabled": _vm.disabled,
      "type": "text",
      "readonly": "",
      "tabindex": "-1"
    },
    domProps: {
      "value": _vm.endValue
    }
  }), _vm.isCanClear ? _c('icon', {
    class: _vm.prefixCls + "-picker-clear",
    attrs: {
      "type": "close_circle"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onClearClick($event);
      }
    }
  }) : _vm._e(), _c('span', {
    class: _vm.prefixCls + "-picker-icon"
  })], 1)])])], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "rangeDatePicker.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;